import { useState } from 'react';
import { Sidebar, NavMenu, NavItem } from '@celltrak/ui-components';

import useSidebarMenu from './hooks';

function SidebarMenu() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { active, handleSidebarClick } = useSidebarMenu();

  return (
    <Sidebar
      topMenu={
        <NavMenu>
          <NavItem
            active={active === 'business-section'}
            id="sidebar-business-button"
            icon="fa-solid fa-file-chart-column"
            onClick={() => handleSidebarClick('business-section', '/evv/business')}
          >
            Business Summary
          </NavItem>
          <NavItem
            active={active === 'rejected-section'}
            id="sidebar-rejected-button"
            icon="fa-solid fa-file-chart-column"
            onClick={() => handleSidebarClick('rejected-section', '/evv/rejected')}
          >
            Rejected Summary
          </NavItem>
          <NavItem
            active={active === 'visits-section'}
            id="sidebar-visits-button"
            icon="fa-solid fa-file-chart-column"
            onClick={() => handleSidebarClick('visits-section', '/evv/visits')}
          >
            Visit Summary
          </NavItem>
          <NavItem
            active={active === 'setup-section'}
            id="sidebar-setup-button"
            icon="fa-solid fa-screwdriver-wrench"
            onClick={() => handleSidebarClick('setup-section', '/evv/setup')}
          >
            Setup
          </NavItem>
        </NavMenu>
      }
      isCollapsed={isCollapsed}
      onCollapseClick={() => setIsCollapsed(!isCollapsed)}
      collapseButtonAriaLabel="Collapse navigation bar"
    />
  );
}

export default SidebarMenu;
